<div class="calendar-header-container">
  <button mat-icon-button class="navigation-button" data-test-id="date_picker_arrow_left"
          (click)="previousClicked('month')">
    <mat-icon class="nav-button-icon">keyboard_arrow_left</mat-icon>
  </button>
  <span class="header-label medium">{{periodLabel}}</span>
  <button mat-icon-button class="navigation-button" data-test-id="date_picker_arrow_right"
          (click)="nextClicked('month')">
    <mat-icon class="nav-button-icon">keyboard_arrow_right</mat-icon>
  </button>
</div>
